import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/globals.css';
import { reloadOnStaleChunk } from './utils/staleChunkReload';

window.addEventListener('vite:preloadError', reloadOnStaleChunk);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
